'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _components = require('../../../components');
var _OMInputFieldRow = require('./OMInputFieldRow.scss');var _OMInputFieldRow2 = _interopRequireDefault(_OMInputFieldRow);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =

function (properties) {return (
    _react2.default.createElement('div', { className: _OMInputFieldRow2.default.rowWrapper },
      _react2.default.createElement(_components.OMFiltersTitle, { label: properties.label }),
      _react2.default.createElement(_components.OMInputField, _extends({}, properties.field, { isRtl: properties.isRtl }))));};module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMInputFieldRow/OMInputFieldRow.js
// module id = 2705
// module chunks = 0